import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=5a5e16c8&"
import script from "./Cart.js?vue&type=script&lang=js&"
export * from "./Cart.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports